import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

import { usePreDepositModals } from '../../../hooks/usePreDepositModals'
import { StyledWrapper, StyledPageWrapper } from './style'
import { KycStatus, ModalTypes, PaymentTypes } from '../../../utils/constants'
import { getPlayerBankAccounts } from '../../../utils/getPlayerBankAccounts'
import { useLoading } from '../../../hooks/useLoading'
import { WithdrawDrawer } from '../WithdrawDrawer'
import { BankAccountWithdrawVerification } from '../../molecules/BankAccountWithdrawVerification'
import { useModalContext } from '../../../context/modalProvider'
import { Modal } from '../../atoms/modal'
import { useTranslation } from '../../../context/translationProvider'

export const BankAccountWithdrawFlow = ({
  method,
  isOpen,
  onClose,
  paymentIQHeight,
  hideOverlay,
  isMobile,
  isPage,
}) => {
  const { translate } = useTranslation()
  const { open: openWithdrawDrawer } = useModalContext()
  const { openLivenessModal } = usePreDepositModals()
  const [doNotHaveBankAccount, setDoNotHaveBankAccount] = useState(null)
  const { isLoading, startLoading, stopLoading } = useLoading()

  const getInitialData = async () => {
    startLoading()

    const {
      inactiveAccounts,
      DO_NOT_HAVE_BANK_ACCOUNT,
      HAVE_BANK_ACCOUNT_PENDING_VALIDATION,
      HAVE_BANK_ACCOUNT_PENDING_LIVENESS,
    } = await getPlayerBankAccounts()

    stopLoading()

    if (DO_NOT_HAVE_BANK_ACCOUNT || HAVE_BANK_ACCOUNT_PENDING_VALIDATION) {
      return setDoNotHaveBankAccount(true)
    }

    setDoNotHaveBankAccount(false)

    if (HAVE_BANK_ACCOUNT_PENDING_LIVENESS) {
      const waitingLivenessAccounts = inactiveAccounts.filter(
        ({ status }) => status === KycStatus.WAITING_LIVENESS
      )

      openLivenessModal(
        waitingLivenessAccounts[0],
        onClose,
        onClose,
        PaymentTypes.WITHDRAW
      )
      return
    }
  }

  useEffect(() => {
    getInitialData()
  }, [])

  if (!method || isLoading || doNotHaveBankAccount === null) return null

  if (doNotHaveBankAccount) {
    return (
      <Modal
        theme="payments"
        title={translate('payments.withdraw.title')}
        id="withdraw-modal"
        isOpen={isOpen}
        onClose={onClose}
        paymentIQMinHeight={paymentIQHeight ? paymentIQHeight + 95 : null}
        hideOverlay={hideOverlay ? hideOverlay : null}
        isMobile={isMobile ? isMobile : null}
        isPage={isPage ? isPage : null}
      >
        <StyledWrapper>
          <BankAccountWithdrawVerification onClose={onClose} />
        </StyledWrapper>
      </Modal>
    )
  }

  if (isPage) {
    return (
      <StyledPageWrapper>
        <WithdrawDrawer isPage={isPage} />
      </StyledPageWrapper>
    )
  }

  return openWithdrawDrawer({ type: ModalTypes.WITHDRAWDRAWER })
}

BankAccountWithdrawFlow.propTypes = {
  method: PropTypes.string,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  paymentIQHeight: PropTypes.number,
  isMobile: PropTypes.bool,
  hideOverlay: PropTypes.bool,
  isPage: PropTypes.bool,
}
